import { JsonFormsRendererRegistryEntry, rankWith, uiTypeIs } from '@jsonforms/core';
import layoutRenderer from './HorizontalLayoutRenderer.vue';

export const entry: JsonFormsRendererRegistryEntry = {
  renderer: layoutRenderer,
  tester: rankWith(2, uiTypeIs('HorizontalLayout')),
};
